module.exports = __webpack_public_path__ + "assets/img/m2.4d95726a.png";